/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
import './bus';
import './bootstrap';
import SvgVue from 'svg-vue';
import VueLazyload from 'vue-lazyload';
import VuePromiseBtn from 'vue-promise-btn';
import 'vue-promise-btn/dist/vue-promise-btn.css';
import Vuex from 'vuex';
import VTooltip from 'v-tooltip';
import Chat from 'vue-beautiful-chat';
import Toasted from 'vue-toasted';

import timelineStore from './stores/timeline-store';

window.Vue = Vue;

Vue.use(SvgVue);
Vue.use(VueLazyload);
Vue.use(VuePromiseBtn);
Vue.use(Chat);
Vue.use(Vuex);
Vue.use(Toasted);
Vue.use(VTooltip, {
  defaultTrigger: 'hover focus click',
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map((key) => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

const store = new Vuex.Store({
  modules: {
    timeline: timelineStore,
  },
});

export const App = new Vue({
  store,
  el: '#app',
});
